import { useContext, createContext } from 'react';

var MotionContext = createContext({});
function useVisualElementContext() {
    return useContext(MotionContext).visualElement;
}

export { MotionContext, useVisualElementContext };
